export default __webpack_public_path__ + "static/media/mail.12052d16.svg";